import Pagination from 'app/components/pagination'
import {getShippingPackages} from 'app/features/orders/redux/shippingService/shippingPackagesSlice'
import {FC, useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {Loader} from '_core/components/Loader'
import PackageItem from './ShippingPackageItem'

type Props = {
  shippingPackage: any
  onChange: (shippingPackage: any) => void
}

const pageSize = 5

const PackageList: FC<Props> = ({shippingPackage, onChange}) => {
  const dispatch = useDispatch()
  const [filter, setFilter] = useState({
    offset: 0,
    pageSize,
  })

  const paging = useSelector<RootState>(({misc}) => misc.paging) as any

  const shippingPackages = useSelector<RootState>(
    ({orders}) => orders.shippingService.packages.list
  ) as any[]

  const isFetching = useSelector<RootState>(
    ({orders}) => orders.shippingService.packages.isFetching
  ) as boolean

  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    dispatch(getShippingPackages(filter))
  }, [dispatch, filter])

  const handlePageChange = async (currentPage: any) => {
    await fetchOrders(currentPage - 1)
    setCurrentPage(currentPage)
  }

  const fetchOrders = async (currentOrderPage: number) => {
    const offset = currentOrderPage * pageSize
    const order = {
      ...filter,
      offset,
    }
    dispatch(getShippingPackages(order))
    setFilter(order)
  }

  if (isFetching) {
    return <Loader show={isFetching} />
  }
  return (
    <>
      {shippingPackages.map((item, index) => (
        <PackageItem
          key={index}
          shippingPackage={item}
          selected={item.id === shippingPackage.id}
          onChange={onChange}
        />
      ))}
      <Pagination
        totalCount={paging.totalCount}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        pageSize={pageSize}
      />

      {shippingPackages.length > 0 && !shippingPackage.id && (
        <div className='my-5'>
          <i className='bi bi-exclamation-circle-fill text-danger me-2'></i>
          <span className='text-danger'>Please select package</span>
        </div>
      )}
    </>
  )
}

export default PackageList
